/** localStorage-Key fuer das Dev-JWT (Sandcastle-Tests, non-production only). */
export const DEV_JWT_KEY = 'dev_jwt';
